import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Dropdown, Layout, Row, Space, Input } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import type { MenuProps } from 'antd';
import CustomDrawer from '../../shared/components/Drawer';
import CesiumMap from '../CesiumMap';
import CustomModal from '../../shared/components/Modal';
import CustomSlider from '../../shared/components/Slider';
import CustomColorPalette from '../../shared/components/ColorPalette';
import './3DViewer.scss';

const { Content } = Layout;

interface DrawerItem {
  temporaryLayerName: string;
  elevation: number | null;
}

const items: MenuProps['items'] = [
  {
    label: 'Feet',
    key: '1',
  },
  {
    label: 'metres',
    key: '2',
  },
];

const HeaderItems: MenuProps['items'] = [
  {
    label: 'Map View',
    key: '3',
  },
  {
    label: 'List View',
    key: '4',
  },
];

const CesiumViewer: React.FC = () => {
  const [dropDownText, setDropDownText] = useState<string>('Meters');
  const [dropDownTextHeader, setDropDownTextHeader] = useState<string>('Map View');
  const [drawerItems, setDrawerItems] = useState<DrawerItem[]>([]);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [temporaryLayerName, setTemporaryLayerName] = useState<string>('');
  const [elevationValue, setElevationValue] = useState<number | null>(null);

  useEffect(() => {
    const handleClick = (): void => setIsModalOpen(true);

    const element = document.getElementsByClassName('distance-legend-label');

    if (element[0]) {
      element[0].addEventListener('click', handleClick);
    }

    return () => {
      if (element[0]) {
        element[0].removeEventListener('click', handleClick);
      }
    };
  }, []);

  const addItemToDrawer = (item: DrawerItem) => {
    setDrawerItems((prevItems) => [...prevItems, item]);
  };

  const handleMenuClick: MenuProps['onClick'] = (e) => {
    const selectedItem = items?.find((i) => i?.key === e.key);
    if (selectedItem && 'label' in selectedItem) {
      setDropDownText(selectedItem.label as string);
    }
  };

  const handleMenuClickHeader: MenuProps['onClick'] = (e) => {
    const selectedItem = items?.find((i) => i?.key === e.key);
    if (selectedItem && 'label' in selectedItem) {
      setDropDownTextHeader(selectedItem.label as string);
    }
  };

  const menuProps: MenuProps = {
    items,
    onClick: handleMenuClick,
  };

  const headerMenuProps: MenuProps = {
    items: HeaderItems,
    onClick: handleMenuClickHeader,
  };

  const handleOk = () => {
    setIsModalOpen(false);
    addItemToDrawer({
      temporaryLayerName: temporaryLayerName,
      elevation: elevationValue,
    });
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <Layout className="viewer_layout">
      <h2 className="heading" style={{ textAlign: 'center', color: 'white' }}>
        3D Viewer
      </h2>
      <Content>
        <Dropdown menu={headerMenuProps}>
          <Button
            style={{
              marginLeft: '2rem',
              marginBottom: '20px',
              backgroundColor: '#5D5C5C',
              color: 'white',
              borderColor: '#5D5C5C',
            }}
          >
            <Space>
              {dropDownTextHeader}
              <DownOutlined />
            </Space>
          </Button>
        </Dropdown>
        <Row justify="center" gutter={[16, 16]}>
          <Col xs={22} sm={22} md={22} lg={23}>
            <Card
              className="card-style"
              style={{
                textAlign: 'center',
                backgroundColor: '#5D5C5C',
                borderColor: '#5D5C5C',
                color: 'white',
                minHeight: '50vh',
                maxHeight: '100vh',
                height: 'calc(80vh + 20px)',
              }}
            >
              <CesiumMap containerId={'1'} />
              <CustomModal
                isModalOpen={isModalOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                title="Edit Flood Model"
                okText="Update Model"
                footerContent={null}
              >
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <p>Temporary Layer Name</p>
                  <Input placeholder="Basic usage" onChange={(e) => setTemporaryLayerName(e.target.value)} />
                  <p style={{ marginTop: '20px' }}>Elevation</p>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                    }}
                  >
                    <Input
                      placeholder="Basic usage"
                      style={{ marginRight: '0.5rem' }}
                      onChange={(e) => setElevationValue(parseFloat(e.target.value))}
                    />
                    <Dropdown menu={menuProps}>
                      <Button
                        style={{
                          backgroundColor: '#076169',
                          color: 'white',
                          borderColor: '#076169',
                          width: '100%',
                        }}
                      >
                        <Space>
                          {dropDownText}
                          <DownOutlined />
                        </Space>
                      </Button>
                    </Dropdown>
                  </div>
                  <CustomSlider />
                  <p style={{ marginTop: '20px' }}>Colour</p>
                  <CustomColorPalette />
                </div>
              </CustomModal>
              <CustomDrawer drawerItems={drawerItems} />
            </Card>
          </Col>
        </Row>
      </Content>
    </Layout>
  );
};

export default CesiumViewer;
